package fr.xibalba.generateurClassesLycee.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import fr.xibalba.generateurClassesLycee.GlobalData

@Page
@Composable
fun AgencementPage() {
    if (GlobalData.fichier == null) return

    //val agencer = Agencer()
}